import * as React from 'react';
import CurrentSlide from './currentSlide';

const MAIN_CONTENT_ID = 'lessons-main-content';

interface MainContentContainerProps extends React.Props<any> {
  params: any,
  onOpenSidebar?: () => void
}

const MainContentContainer = (props:MainContentContainerProps) =>
  (
    <main
      aria-label="Current slide content"
      className="main-content"
      id={MAIN_CONTENT_ID}
      tabIndex={-1}
    >
      {props.onOpenSidebar && (
        <button
          aria-label="Open slides sidebar"
          className="open-sidebar-button focus-on-light"
          onClick={props.onOpenSidebar}
          type="button"
        >
          <i className="fa fa-bars" />
          <span>Slides</span>
        </button>
      )}
      <div className="main-content-wrapper">
        <CurrentSlide match={props.match} />
      </div>
    </main>
  );

export default MainContentContainer;
